import { render, staticRenderFns } from "./GlobalSearch.vue?vue&type=template&id=50921495&scoped=true"
import script from "./GlobalSearch.vue?vue&type=script&lang=js"
export * from "./GlobalSearch.vue?vue&type=script&lang=js"
import style0 from "./GlobalSearch.vue?vue&type=style&index=0&id=50921495&prod&lang=scss&scoped=true"
import style1 from "./GlobalSearch.vue?vue&type=style&index=1&id=50921495&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50921495",
  null
  
)

export default component.exports